const TikTokProductCard = (productID: number, productName: string) => {
  if (window?.ttq?.track && typeof window.ttq.track === 'function') {
    window.ttq.track('viewProduct', {
      content_name: productName,
      content_id: productID
    });
  }
};
export default TikTokProductCard;